import React, { useEffect, useState } from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { ClientVerification } from 'api/Clients/Types/ClientVerification'
import { Box } from 'components/Box'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { formatLocalDateUTC } from 'utils/date'
import { TableWithExport } from 'utils/table/withExport'

import ClientDetailsVerificationReportDetails from './ClientDetailsVerificationReportDetails'

const ClientDetailsKYC: React.FC<{ data: ClientDetailedDto }> = ({ data }) => {
  const clientsApiClient = useApiClient(ClientsApiClient)
  const [clientVerifications, setClientVerifications] = useState<ClientVerification[]>([])
  const [modalReportId, setModalReportId] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await clientsApiClient.getClientIdentityVerification(data.id)
        setClientVerifications(result)
      } catch (error) {
        console.error(error)
      }
    }
    fetchData()
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps

  if (modalReportId) {
    return (
      <Box display='flex' flexDirection='column' style={{ width: '90%', margin: '5rem' }}>
        <ClientDetailsVerificationReportDetails
          reportId={modalReportId}
          client={`${data.firstname} ${data.lastname}`}
        />
      </Box>
    )
  }

  return (
    <Box display='flex' flexDirection='column' style={{ margin: '2rem' }}>
      <TableWithExport data={clientVerifications}>
        <Grid data={clientVerifications} resizable>
          <Column
            cell={(props: GridCellProps) => {
              return (
                <td
                  onClick={() => setModalReportId(props.dataItem.reportId)}
                  style={{ color: 'var(--link)', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {props.dataItem.reportId}
                </td>
              )
            }}
            title='Report Id'
            field='reportId'
            className='table-columns__content'
          />
          <Column field='provider.name' title='Provider' className='table-columns__content' />
          <Column field='status.name' title='Status' className='table-columns__content' />
          <Column
            cell={(props: GridCellProps) => (
              <td className='transaction-columns__date'>
                {formatLocalDateUTC(props.dataItem.createdDate)}
              </td>
            )}
            field='createdDate'
            title='Created Date'
            className='table-columns__date'
          />
        </Grid>
      </TableWithExport>
    </Box>
  )
}

export default ClientDetailsKYC
